import { Component, effect, signal, WritableSignal } from '@angular/core';
import { CoreModule } from '@abp/ng.core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@digiwall/goliath-core';
import {
  StorageLocationLookupRequestDto,
  StorageLocationService,
} from '@digiwall/goliath-core/proxy';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DwApiSelectDirective } from '@digiwall/core';

@Component({
  selector: 'document-ask-location-modal',
  templateUrl: './ask-location-modal.component.html',
  styleUrls: ['./ask-location-modal.component.scss'],
  imports: [SharedModule, CoreModule, DwApiSelectDirective],
})
export class AskLocationModalComponent {
  public defaultLocationId: WritableSignal<string> = signal(null);

  protected form: FormGroup;

  constructor(
    protected modal: NgbActiveModal,
    protected formBuilder: FormBuilder,
    private storageLocationService: StorageLocationService,
  ) {
    this.form = this.formBuilder.group({
      locationId: [this.defaultLocationId(), Validators.required],
    });

    effect(() => {
      this.form.reset({
        locationId: this.defaultLocationId(),
      });
    });
  }

  protected save() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.modal.close(this.form.get('locationId').value);
  }

  protected storageLocationSelect = (dto: StorageLocationLookupRequestDto) => {
    dto.onlyActive = true;
    dto.onlyReservable = true;
    dto.queryProperties = ['code', 'name'];
    dto.sorting = [{ property: 'code' }];
    return this.storageLocationService.getLookupList(dto);
  };
}
